// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AppEnvironment } from './app-environment.models';
import * as prodAppConfig from './settings/settings.prod.json';

export const environment: AppEnvironment = {
  appConfig: prodAppConfig,
};
